var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"footer-text"},[_c('p',[_vm._v("Copyright © 2025.西安航装电子科技有限公司 All rights reserved.")])])])])
}]

export { render, staticRenderFns }